import { useCallback } from 'react';

import { useVideoCreatorStore } from '../stores-v2';
import { extractErrorInfo } from '../utility/error';
import { LogManager } from '../utility/Logger';

import type { ElementState } from '../renderer/ElementState';

const logger = LogManager.getLogger('hooks:useRefreshActiveElement');

export function useRefreshActiveElement() {
  const videoCreator = useVideoCreatorStore();
  const videoSourceStore = videoCreator.rootStore.videoSourceStore;

  return useCallback(
    async (baseElement: ElementState | undefined) => {
      if (!baseElement) {
        return;
      }

      const cb = () => {
        try {
          videoCreator.setActiveElement(baseElement);
        } catch (error) {
          logger.warn(
            'Failed to refresh active element',
            extractErrorInfo(error),
          );
        }
      };

      await videoCreator.setActiveElements();

      if (videoSourceStore.hasDebouncedSourceRefresh) {
        videoSourceStore.onNextSourceRefresh(cb);
      } else {
        cb();
      }
    },
    [videoCreator, videoSourceStore],
  );
}
